import DossierTechniqueWizardPage from "@features/creation/dossier-techniques/components/DossierTechniqueWizardPage";
import { useDossierTechniqueDetail } from "@features/creation/dossier-techniques/hooks/useDossierTechniques";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/creation/dossier-techniques/$id/edit")({
  loader: requirePermission(PERMISSIONS.CREATION.DOSSIER_TECHNIQUES.EDIT),
  staticData: {
    title: "Modifier le dossier technique",
    icon: null,
    permission: PERMISSIONS.CREATION.DOSSIER_TECHNIQUES.EDIT,
    section: "Creation",
    showInBreadcrumb: true,
  },
  component: EditDossierTechniquePage,
});

function EditDossierTechniquePage() {
  const { id } = useParams({ from: "/_app/creation/dossier-techniques/$id/edit" });
  const { data: dossier, isLoading, error } = useDossierTechniqueDetail(id);

  if (isLoading) {
    return (
      <div className="space-y-4 p-4">
        <div className="skeleton h-8 w-48" />
        <div className="skeleton h-64 w-full" />
      </div>
    );
  }

  if (error || !dossier) {
    return (
      <div className="alert alert-error">
        <span>Erreur lors du chargement du dossier technique.</span>
      </div>
    );
  }

  return <DossierTechniqueWizardPage initialData={dossier} />;
}
